import type { ReactNode } from "react";

/**
 * Centered "couldn't load" panel shared by the route error component, the study/list views and
 * the root crash fallback. Purely presentational so it can render anywhere, including outside the
 * router and query providers.
 */
export function LoadErrorState({
  title,
  description,
  children,
  testId = "load-error",
}: {
  title: string;
  description: string;
  /** Action buttons, rendered in a row under the copy. */
  children?: ReactNode;
  testId?: string;
}) {
  return (
    <div
      data-testid={testId}
      role="alert"
      className="flex h-full w-full flex-col items-center justify-center gap-3 p-6 text-center"
    >
      <h2 className="text-headline font-normal text-foreground">{title}</h2>
      <p className="max-w-sm text-body text-muted-foreground">{description}</p>
      {children ? <div className="flex items-center gap-2 pt-1">{children}</div> : null}
    </div>
  );
}
